import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { ToggleSizes, ToggleSizesPropTypes } from "./PropTypes/ToggleSizes";
const Toggle = ({ children, className, disabled, name, options = [], onChange, size }) => {
    const [selectedIdOption, setSelectedIdOption] = useState(null);
    useEffect(() => {
        var _a;
        const defaultOptionIdChecked = ((_a = options.find((option) => option.checked)) === null || _a === void 0 ? void 0 : _a.uuid) || null;
        setSelectedIdOption(defaultOptionIdChecked);
    }, [options]);
    const handleChange = (e, uuid) => {
        if (onChange) {
            onChange(e, uuid);
        }
        setSelectedIdOption(uuid);
    };
    return (React.createElement("div", { className: classNames("gerudo-toggle", className, {
            lg: size === ToggleSizes.large,
            sm: size === ToggleSizes.small,
        }) }, options.map((el, i) => {
        const isSelected = selectedIdOption === el.uuid;
        const uid = i + 1;
        const Icon = el.icon;
        return (React.createElement("div", { className: classNames("option-container", {
                "option-container-checked": isSelected,
            }), key: el.uuid },
            React.createElement("input", { type: "radio", name: `toggle__${name}`, id: `option-${el.uuid}`, checked: isSelected, disabled: disabled, onChange: (e) => !disabled && handleChange(e, el.uuid) }),
            React.createElement("label", { htmlFor: `option-${el.uuid}`, className: classNames(`option option-${uid}`, {
                    "option-checked": isSelected,
                }) },
                React.createElement("span", { className: "option-text" },
                    Icon && React.createElement(Icon, null),
                    el.label))));
    })));
};
const optionShape = {
    label: PropTypes.node,
    uuid: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    className: PropTypes.string,
};
Toggle.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    disabled: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.shape(optionShape)),
    onChange: PropTypes.func,
    size: ToggleSizesPropTypes,
};
Toggle.defaultProps = {
    size: ToggleSizes.small,
};
export default Toggle;
export { Toggle };
//# sourceMappingURL=index.js.map